import { useState } from 'react';
import { X } from 'lucide-react';

export default function BooksGrid(props) {
  const { title, writer, pict, quotes, howDiscovered, oneLinerDescription } = props;
  const [showQuotesModal, setShowQuotesModal] = useState(false);

  const openQuotes = () => setShowQuotesModal(true);
  const closeQuotes = () => setShowQuotesModal(false);

  return (
    <>
      <div className="card mb-6">
      <div className="flex flex-col md:flex-row gap-6">
        {/* Book Cover */}
        <div className="flex-shrink-0 flex justify-center md:justify-start">
          <img
            className="w-32 h-48 object-cover rounded"
            alt={title}
            src={pict}
          />
        </div>

        {/* Book Details */}
        <div className="flex-1 space-y-4">
          <div>
            <h3 className="text-xl font-semibold text-foreground">{title}</h3>
            <p className="text-muted">{writer}</p>
          </div>

          {oneLinerDescription && (
            <p className="text-muted text-sm leading-relaxed">
              {oneLinerDescription}
            </p>
          )}

          {howDiscovered && (
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">How I Discovered It</h4>
              <p className="text-muted text-sm">{howDiscovered}</p>
            </div>
          )}

          {quotes && quotes.length > 0 && (
            <div>
              <h4 className="text-sm font-medium text-foreground mb-2">Key Quotes</h4>
              <div className="space-y-2">
                {quotes.slice(0, 3).map((quote, index) => (
                  <p key={index} className="text-muted text-sm italic border-l-2 border-border pl-3">
                    {quote}
                  </p>
                ))}
                {quotes.length > 3 && (
                  <button onClick={openQuotes} className="text-muted text-xs hover:underline">
                    + {quotes.length - 3} more quotes
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      </div>
      {showQuotesModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
        <div className="bg-card border border-border rounded-lg w-full max-w-2xl mx-4 p-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-foreground">Quotes from {title}</h3>
            <button onClick={closeQuotes} className="p-1 rounded hover:bg-card-hover text-foreground">
              <X size={18} />
            </button>
          </div>
          <div className="space-y-3 max-h-[60vh] overflow-y-auto">
            {quotes.map((q, i) => (
              <p key={i} className="text-muted text-sm italic border-l-2 border-border pl-3">{q}</p>
            ))}
          </div>
        </div>
      </div>
      )}
    </>
  );
}
